<template>
  <div>
    <json-viewer
      v-if='file'
      :value='file'
      :expand-depth=5
      :expanded='true'
      copyable
      boxed
      sort>
    </json-viewer>
  </div>
</template>

<script>

export default {
  name: 'ViewJsonFile',
  props: {
    file: { default: null }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang='scss' scoped>
</style>
